/* eslint-disable max-len */
/* eslint-disable import/extensions */
import React, { useState } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Badge, Button, Col, Modal, Row, } from 'react-bootstrap';
import { FaEnvelope, FaFacebook, FaInstagram, FaLinkedin, FaMapPin, FaYoutube, FaShieldHalved, FaWhatsapp, } from 'react-icons/fa6';
import { auth } from '@/services/auth';
import { layout, http, messages, version, } from '@/helpers/index';
import Divider from './divider';
import Image from 'next/image';

export default function Footer({ className, profile, crm }) {
  const pathname = usePathname();
  const footerClass = className || 'site text-center';
  const user = auth.store.logged.get();
  const [modalShow, setModalShow] = useState(false);
  const [modalAction, setModalAction] = useState();

  const handleModalInactivate = () => {
    setModalAction('INACTIVATE');
    setModalShow(true);
  };

  const handleInactivate = () => {
    layout.loading(true);
    http.patch(`/users/inactivate/${user._id}`, null, (result) => {
      if (!result) {
        messages.alert('Infelizmente não foi possível fazer a desativação da sua conta neste momento, Por favor, aguarde alguns instantes e tente novamente ou entre em contato através do e-mail: contato@aboutcar.com.br.', false, true);
        layout.loading(false);
        return;
      }
      auth.logout();
      setModalShow(false);
      layout.loading(false);
      window.location.href = '/';
    });
  };

  const handleModalExclude = () => {
    setModalAction('EXCLUDE');
    setModalShow(true);
  };

  const handleExclude = () => {
    layout.loading(true);
    http.delete(`/users/${user._id}`, null, (result) => {
      if (!result) {
        messages.alert('Infelizmente não foi possível fazer a exclusão da sua conta neste momento, Por favor, aguarde alguns instantes e tente novamente ou entre em contato através do e-mail: contato@aboutcar.com.br.', false, true);
        layout.loading(false);
        return;
      }
      auth.logout();
      setModalShow(false);
      layout.loading(false);
      window.location.href = '/';
    });
  };

  const handleCancel = () => {
    setModalShow(false);
  };

  return (
    <footer className={footerClass}>
      <div className="container py-4">
        {(profile || crm) && <Divider color="gray" />}

        <Row className="gy-4 mb-4 text-start">
          <Col xs={12} md={6} lg={3}>
            <div className="fw-bold text-white fs-5 mb-2">AboutCar</div>
            <p className="small text-light opacity-90 mb-3">
              Soluções completas em consulta de histórico veicular por placa. Segurança e transparência para a sua negociação.
            </p>
            <div className="footer-social mt-3">
              <span className="small text-light d-block mb-2 fw-medium">Siga-nos nas redes sociais</span>
              <a href="https://facebook.com/aboutcarbr" target="_blank" rel="noreferrer" title="Facebook AboutCar">
                <FaFacebook />
              </a>
              <a href="https://instagram.com/aboutcarbr" target="_blank" rel="noreferrer" title="Instagram AboutCar">
                <FaInstagram />
              </a>
              <a href="https://youtube.com/@aboutcarbr" target="_blank" rel="noreferrer" title="YouTube AboutCar">
                <FaYoutube />
              </a>
              <a href="https://linkedin.com/company/aboutcar-solucoes" target="_blank" rel="noreferrer" title="LinkedIn AboutCar Soluções">
                <FaLinkedin />
              </a>
              <a href="https://wa.me/553190612941" target="_blank" rel="noreferrer" title="WhatsApp 24/7 AboutCar">
                <FaWhatsapp />
              </a>
            </div>
          </Col>

          <Col xs={6} md={6} lg={3}>
            <div className="fw-bold text-white mb-3">Links Rápidos</div>
            <ul className="list-unstyled small mb-0 d-flex flex-column gap-2">
              <li><Link href="/blog" className="text-white">Blog Oficial</Link></li>
              <li><Link href="/parceria" className="text-white">Parceria</Link></li>
              <li><Link href="/contato" className="text-white">Contato</Link></li>
              <li><Link href="/duvidas-frequentes" className="text-white">Dúvidas Frequentes</Link></li>
              <li><Link href="/acesse-seu-relatorio" className="text-white">Acesse seu Relatório</Link></li>
            </ul>
          </Col>

          <Col xs={6} md={6} lg={3}>
            <div className="fw-bold text-white mb-3">Termos &amp; Segurança</div>
            <ul className="list-unstyled small mb-0 d-flex flex-column gap-2">
              <li><Link href="/privacidade" className="text-white">Política de Privacidade</Link></li>
              <li><Link href="/cookies" className="text-white">Política de Cookies</Link></li>
              <li><Link href="/psi.pdf" target="_blank" className="text-white">PSI</Link></li>
            </ul>
          </Col>

          <Col xs={12} md={6} lg={3}>
            <div className="fw-bold text-white mb-3">Atendimento</div>
            <div className="d-flex align-items-center gap-2 mb-2 small text-light">
              <FaWhatsapp className="flex-shrink-0 fs-6" />
              <a
                href="https://wa.me/553190612941"
                target="_blank"
                rel="noreferrer"
                className="text-white text-decoration-none d-inline-flex align-items-center gap-1 flex-wrap"
              >
                <span>+55 (31) 99061-2941</span>
                <Badge bg="success">WhatsApp 24/7</Badge>
              </a>
            </div>
            <div className="d-flex align-items-center gap-2 mb-2 small text-light">
              <FaEnvelope className="flex-shrink-0" />
              <a href="mailto:contato@aboutcar.com.br" className="text-white text-decoration-none text-nowrap">
                contato@aboutcar.com.br
              </a>
            </div>
            <div className="d-flex align-items-center gap-2 mb-2 small text-light">
              <FaMapPin className="flex-shrink-0" />
              <span>Belo Horizonte / MG</span>
            </div>
            <p className="small text-light mt-3 mb-0">Seg a Sex: 09h às 18h</p>
          </Col>
        </Row>

        {user && pathname.includes('/perfil/minha-area') && (
          <Col xs={12} className="text-center my-2">
            <Button variant="link" className="p-1 text-light small" onClick={handleModalInactivate}>Desativar Conta</Button>
            <span className="ms-1 me-1 text-light">&middot;</span>
            <Button variant="link" className="p-1 text-light small" onClick={handleModalExclude}>Excluir Conta</Button>
          </Col>
        )}

        <div className="border-top border-secondary opacity-50 my-4" />

        <Row className="align-items-center gy-3 text-center text-md-start">
          <Col lg={5} md={6} className="small text-light">
            &copy; {new Date().getFullYear()} AboutCar - {version.site} - Todos os direitos reservados.<br />
            <strong className="text-white">CNPJ: 42.636.052/0001-07</strong>
          </Col>
          <Col lg={7} md={6} className="d-flex justify-content-center justify-content-md-end pe-md-5">
            <div className="footer-security-card d-inline-flex align-items-center gap-3 p-2 px-3 rounded-4 shadow-sm">
              <div className="d-flex align-items-center gap-2 text-start">
                <div className="security-icon-badge rounded-circle p-2 d-flex align-items-center justify-content-center flex-shrink-0">
                  <FaShieldHalved className="text-light fs-5" />
                </div>
                <div className="d-none d-sm-block">
                  <div className="fw-bold text-white fs-7 text-uppercase" style={{ letterSpacing: '0.04em' }}>
                    Ambiente 100% Seguro
                  </div>
                  <span className="text-light opacity-75 d-block" style={{ fontSize: '0.75rem' }}>
                    Criptografia SSL & Navegação Protegida
                  </span>
                </div>
              </div>

              <div className="vr bg-white opacity-25 d-none d-sm-block mx-1" style={{ height: '32px' }} />

              <div className="d-flex align-items-center gap-2">
                <div className="security-badge-wrapper bg-white rounded-3 p-1 shadow-xs">
                  <Image
                    src="/assets/images/google-safe-browsing.webp"
                    width="115"
                    height="38"
                    border="0"
                    alt="Google Safe Browsing"
                    quality={90}
                    style={{ objectFit: 'contain' }}
                  />
                </div>
                <div className="security-badge-wrapper bg-white rounded-3 p-1 shadow-xs">
                  <Image
                    src="/assets/images/ssl-secure.webp"
                    width="90"
                    height="38"
                    border="0"
                    alt="SSL Certificado"
                    quality={90}
                    style={{ objectFit: 'contain' }}
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      {modalShow && (
        <Modal show onHide={() => setModalShow(false)} backdrop="static" size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
          <Modal.Header closeButton>
            <div className="text-center not-printable h2 mt-1">
              {modalAction === 'INACTIVATE' && <span>Deseja realmente desativar sua conta?</span>}
              {modalAction === 'EXCLUDE' && <span>Deseja realmente excluir sua conta?</span>}
            </div>
          </Modal.Header>
          <Modal.Body>
            {modalAction === 'INACTIVATE' && (
              <>
                <div className="fw-bold">Ao desativar sua conta, não receberá mais notificações da AboutCar sobre novos Serviços, Promoções e Cupons de oferta.</div>
                <i>Caso realmente desative sua conta, poderá fazer a reativação acessando novamente nossa Plataforma com seus dados de acesso!</i>
              </>
            )}
            {modalAction === 'EXCLUDE' && (
              <>
                <div className="fw-bold">Ao excluir sua conta todos os seus dados de acesso serão eliminados e não poderá mais utilizar nossa Plataforma.</div>
                <i>Caso realmente exclua sua conta e precise utilizar novamente nossa Plataforma, deverá realizar um novo cadastro!</i>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            {modalAction === 'INACTIVATE' && <Button variant="danger" size="sm" className="shadow-sm" onClick={handleInactivate}>Sim, quero desativar minha conta</Button>}
            {modalAction === 'EXCLUDE' && <Button variant="danger" size="sm" className="shadow-sm" onClick={handleExclude}>Sim, quero excluir minha conta</Button>}
            <Button variant="light" size="sm" className="shadow-sm" onClick={handleCancel}>Cancelar</Button>
          </Modal.Footer>
        </Modal>
      )}
    </footer>
  );
}
